// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rl-2";
export var chatLink = "_rl-0";
export var chatText = "_rl-1";